import { IBuyPackageList } from '../Interfaces';
import { IGridServerSideDatasource, toQuery, IServerSideGetRowsParams } from '@samc/centricity-core';
import { AjaxHelper, IPaginatedList } from '@samc/common';

export class BulkAcquisitionGridDataSource implements IGridServerSideDatasource {
  public pageSize: number = 200;
  public cacheSize: number = 10;
  public adhocFilter: string = '';
  private _rowCount: number;
  private _queryParams: any;
  private _getRowsCallback?: (rows: IPaginatedList<IBuyPackageList>) => void;

  public get count(): number { return this._rowCount; }

  public constructor(private _statusName: string | null, private _verificationToken: string | null) {
    this._rowCount = 0;
    this._queryParams = {};
  }

  public setOnGetRowsCallback(callback: (rows: IPaginatedList<IBuyPackageList>) => void) {
    this._getRowsCallback = callback;
  }

  public async getRows(params: IServerSideGetRowsParams) {
    try {
      const helper = new AjaxHelper('/TransactionManagement/', this._verificationToken, null, null);
      this._queryParams = toQuery(params);
      this._queryParams.handler = 'Packages';

      console.log({ params, queryParams: this._queryParams });

      // @ts-ignore
      const statusFilter = params?.request?.filterModel?.status?.filter;

      if (this._queryParams['sort[desc]'] == undefined && this._queryParams['sort[asc]'] == undefined) {
        this._queryParams['sort[desc]'] = 'modifiedDate'; // if no sort is defined then default to DESC on Modified Date
      }

      // status filter should only override the base filter if it is among the statuses in the base filter
      if (statusFilter !== undefined && (this._statusName === null || this._statusName.includes(statusFilter))) {
        this._queryParams.status = statusFilter;
      } else if(this._statusName !== null) {
        this._queryParams.status = this._statusName;
      }

      const result = await helper.getData<IPaginatedList<IBuyPackageList>>('', this._queryParams);
      this._rowCount = result.fullCount;

      params.success({ rowData: result.items, rowCount: this._rowCount });
      if (this._getRowsCallback !== undefined) {
        this._getRowsCallback(result);
      }
    } catch (err: any) {
      params.fail();
    }
  }

  public ExcelExport() {
    if (this._rowCount > 0) {
      const helper = new AjaxHelper('/TransactionManagement/', this._verificationToken, null, null);
      this._queryParams.handler = 'ExportExcel';
      window.location.href = helper.buildUrl('', this._queryParams);
    }
  }
}